import React, { useEffect, useState } from 'react';
import MuiTable from '../../../../manage/common/commonComponents/MuiTable.js';
import { fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from '../../../common/utils/methods/commonMethods/utilityMethod.js';
import { endpoint } from '../../../common/constant';
import { useFetchDropdown } from '../hook.js'
import { failureToast, successToast } from '../../../common/utils/methods/toasterFunctions/function.js';
import moment from 'moment';
import { AiOutlineEye } from "react-icons/ai";
import Tooltip from '@mui/material/Tooltip';
import AFilterForm from 'components/AFilterForm/AFilterForm.jsx';
import { EMPTY_FILTER_FORM, getDropdowns, getFilterFormFields, searchLoanMaster } from './constants.js';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton.jsx';
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils.js';

const getFormatedDate = (date) => {
    return date ? moment(date).format('DD-MMM-YYYY') : ''
}

const columns = (loanCategoryPaymodes, dropdownValues) => [
    { field: 'loanId', headerName: 'ID', type: 'text', minWidth: 60, mandatory: false, editable: false, disabled: false, flex: 1 },
    {
        field: 'loanValue', headerName: 'Value', minWidth: 140, type: 'text', mandatory: true,
        editable: true, disabled: false,
        restrictSpecialCharacter: false, regEx: /^$|[0-9\/]+$/
    },
    {
        field: 'paymentMode', headerName: 'Payment Mode', minWidth: 140, type: 'singleSelect', valueOptions: loanCategoryPaymodes, width: 100, mandatory: true, editable: true,
    },
    { field: 'vendorName', headerName: 'Vendor name', minWidth: 140, type: 'text', mandatory: true, editable: true, disabled: false, flex: 1 },
    {
        field: 'title', headerName: 'Title', minWidth: 140, mandatory: true, editable: true, disabled: false, flex: 1,
        renderCell: (params) => (
            <div className='w-100 d-flex'>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '85%' }}>{params.value}</span>
                {params.value &&
                    <Tooltip title={params.value}>
                        <div style={{ cursor: 'pointer' }}>
                            <AiOutlineEye className='ml-1' size={16} color='#11cdef' />
                        </div>
                    </Tooltip>
                }
            </div>
        )
    },
    {
        field: 'doIdLength', headerName: 'DO ID length', minWidth: 145, type: 'number', mandatory: true, editable: true, disabled: false, flex: 1,
        renderCell: params => (
            <div>{params?.value || '-'}</div>
        )
    },
    {
        field: 'effectiveFrom', headerName: 'Effective date', type: 'date', mandatory: true, minDate: new Date(), flex: 1,
        minWidth: 130, editable: true, disabled: false, formatter: getFormatedDate
    },
    {
        field: 'effectiveTo', headerName: 'Expiry date', type: 'date', mandatory: true, minDate: new Date(), flex: 1,
        minWidth: 130, editable: true, disabled: false, formatter: getFormatedDate
    },
    {
        field: 'processingFees', headerName: 'Processing fee', minWidth: 140, type: 'number', allowDecimalvalue: true, mandatory: true, flex: 1,
        editable: true, disabled: false, formatter: (data) => '₹ ' + data
    },
    {
        field: 'minimumAmount', headerName: 'Min. loan amt.', minWidth: 140, type: 'number', allowDecimalvalue: true, mandatory: true, flex: 1,
        editable: true, disabled: false, renderCell: params => (<div>{`₹ ${params?.value || '-'}`}</div>)
    },
    {
        field: 'subventionPercentage', headerName: 'Subvention %', minWidth: 130, type: 'number', allowDecimalvalue: true, mandatory: true, flex: 1,
        editable: true, disabled: false, maxValue: 100, formatter: (data) => data + ' %'
    },
    {
        field: 'noOfYears', headerName: 'No. of years', type: 'multiSelect', flex: 1,
        valueOptions: [{ label: 'FIRST', value: 'FIRST' }, { label: 'SECOND', value: 'SECOND' }, { label: 'THIRD', value: 'THIRD' }],
        minWidth: 150, editable: true, disabled: false, sortable:false,
    },
    {
        field: 'career', headerName: 'Career', type: 'multiSelect', flex: 1,
        valueOptions: dropdownValues?.academic_careers || [],
        minWidth: 150, editable: true, disabled: false, mandatory: true,
        sortable:false,
    },
    {
        field: 'term', headerName: 'STRM (Term)', type: 'multiSelect', flex: 1,
        valueOptions: dropdownValues?.terms || [],
        minWidth: 150, editable: true, disabled: false, mandatory: true, sortable:false,

    },
    { field: 'lastUpdate', headerName: 'Last update', minWidth: 160, type: 'text', mandatory: false, editable: false, disabled: false, flex: 1, },
    {
        field: 'status', headerName: 'Status', minWidth: 160, type: 'toggle', mandatory: true, editable: true, disabled: false, flex: 1,
        dataLabelOn: "ACTIVE", dataLabelOff: "INACTIVE"
    },
];

const LoanSchemeMaster = ({ userPermissions }) => {

    const [schemes, setSchemes] = useState([]);
    const [loanCategoryPaymodes, setLoanCategoryPaymodes] = useState([]);
    const dropdownValues = useFetchDropdown();
    const [loading, setLoading] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);
    const [filterForm, setFilterForm] = useState({ ...EMPTY_FILTER_FORM });
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...filterForm }));

    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }))
    }

    function createSchemes(schemesPayload, paymodes = loanCategoryPaymodes) {

        return schemesPayload.map(scheme => {

            const { id, value, vendorName, title, effectiveFrom, effectiveTo, processingFees, subventionPercentage, noOfYears, updatedOn, updatedBy, status, doIdLength, minimumAmount, payModeId } = scheme;


            return {
                id: id,
                loanId: id,
                loanValue: value,
                vendorName,
                title,
                effectiveFrom,
                effectiveTo,
                processingFees,
                subventionPercentage,
                noOfYears: noOfYears.map(item => ({ label: item, value: item })),
                career: (scheme?.loanSchemeAcadmicCareerMappings || []).map(mapping => ({ label: mapping.acadmicCareer, value: mapping.acadmicCareerId })),
                term: (scheme?.loanSchemeTermMappings || []).map(mapping => ({ label: mapping.term, value: mapping.termId })),
                lastUpdate: `${updatedBy}, ${getFormatedDate(updatedOn)}`,
                status,
                fromBE: true,
                doIdLength: doIdLength,
                minimumAmount: minimumAmount,
                paymentMode: paymodes?.filter(paymode => paymode?.value === payModeId)
            }
        })
    }

    async function getAllLoanSchemes(paymodes = loanCategoryPaymodes) {
        setLoading(true);
        try {
            const response = await fetchAllPromisedData(`${endpoint.loanScheme}/all`);
            setLoading(false);
            if (response) {
                const data = createSchemes(response, paymodes);
                setSchemes(data);
            } else {
                failureToast("Failed to fetch Data");
            }
        } catch (error) {
            setLoading(false);
            failureToast("Failed to fetch Data");
        }
    }

    const applyFilterHandler = async (reqObj = {}, paymodes = loanCategoryPaymodes) => {
        try {
            setLoading(true);
            setFilterForm(prev => ({
                ...prev,
                appliedFilterCount: getAppliedFilterCount(filterForm)
            }));
            const reqBody = updateRequest(reqObj);
            //calling search api
            const response = await searchLoanMaster(reqBody);
            if (response?.code === 200) {
                const content = response?.data?.content || [];
                setSchemes(createSchemes(content, paymodes));
            } else {
                failureToast("Failed to fetch Data");
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const getAllLoanPaymentModes = async () => {
        const allActivePaymentCategories = await fetchAllPromisedData(endpoint.paymentMode.getAllActivePaymentCategory);
        const loanPaymentCategory = allActivePaymentCategories?.find(category => category?.displayValue === "Loan");
        const resp = await fetchAllPostPromisedData(`${endpoint.paymentMode.search}?offset=0`, { paymentCategories: [loanPaymentCategory?.id] });

        if (resp?.code === 200) {
            const loanCategoryPaymentMethods = resp?.data ?? [];
            return loanCategoryPaymentMethods?.map(el => ({ ...el, label: el?.paymentModeKey, value: el?.id }));
        }

        return [];

    }

    const init = async () => {
        try {
            setLoading(true);
            const res = await getDropdowns();
            const allLoanCategoryPaymodes = await getAllLoanPaymentModes();
            await getAllLoanSchemes(allLoanCategoryPaymodes);
            setLoanCategoryPaymodes(allLoanCategoryPaymodes);
            setDropdowns(res);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, [])

    async function deleteScheme(row) {
        setLoading(true);
        const p = new Promise((resolve, reject) => {
            fetchAllPostPromisedData(`${endpoint.loanScheme}/${row.id}`, {}, 'delete')
                .then(response => {
                    setLoading(false);
                    if (response && response.code === 200) {
                        successToast('Loan scheme master deleted successfully!');
                        resolve(row);
                    } else {
                        failureToast(response.message)
                        reject(response.message);
                    }
                })
                .catch(err => { setLoading(false); reject(err); });
        });
        return p;
    }

    function createSchemesPayload(row) {

        function createValues(arr) {
            const data = [...arr];
            if (arr[0]?.value === "*") {
                data.shift();
            }
            return data.map(item => item.value);
        }



        const selectedPaymode = row?.paymentMode?.[0];

        const request = {
            value: row.loanValue,
            vendorName: row.vendorName,
            title: row.title,
            effectiveFrom: row.effectiveFrom,
            effectiveTo: row.effectiveTo,
            processingFees: +row.processingFees,
            subventionPercentage: +row.subventionPercentage,
            noOfYears: createValues(row.noOfYears),
            loanSchemeAcadmicCareerMappings: (row.career || []).filter(item => item.value != '*').map(career => ({ acadmicCareerId: career.value, acadmicCareer: career.label })),
            loanSchemeTermMappings: (row.term || []).filter(item => item.value != '*').map(term => ({ termId: term.value, term: term.label })),
            status: row.status,
            doIdLength: row.doIdLength,
            minimumAmount: row.minimumAmount,
            payModeId: selectedPaymode?.value,
            payModeValue: selectedPaymode?.label
        }
        return request;
    }
    async function saveScheme(row) {
        setLoading(true);

        const request = createSchemesPayload(row);
        const isRowNew = row.fromBE !== true;

        const p = new Promise((resolve, reject) => {
            fetchAllPostPromisedData(`${endpoint.loanScheme}${isRowNew ? '' : '/' + row.id}`, request, isRowNew ? 'post' : 'put')
                .then(response => {
                    setLoading(false);
                    if (response && response.code === 200) {
                        successToast(`Loan scheme master ${isRowNew ? 'added' : 'edited'} successfully!`);
                        if (isRowNew) {
                            getAllLoanSchemes();
                        }
                        resolve(row);
                    } else {
                        failureToast(response.message)
                        reject(response.message);
                    }
                })
                .catch(err => { setLoading(false); reject(err); });
        });
        return p;
    }

    const loanSchemeHeaderComp = (
        <div className='h-100 d-flex align-items-center'>
            <h2 style={{ fontWeight: 600 }}>Loan scheme master</h2>
        </div>);

    const headerMiscellaneousRightComp = (
        <AFilterForm
            formFields={getFilterFormFields(dropdowns, filterForm)}
            filterForm={filterForm}
            btnComponent={
                <AButton
                    variant="outline"
                    size="sm"
                    updatedStyle={{
                        minWidth: "61px",
                        ...(filterForm?.appliedFilterCount > 0
                            ? { border: "1px solid #00B0F5", color: "#00B0F5" } 
                            : { border: "1px solid #bfbfbf", color: "#000" }), 
                    }}
                >
                    Filters {filterForm?.appliedFilterCount > 0 && <>({filterForm.appliedFilterCount})</>}
                </AButton>
            }
            handleFilterForm={filterFormHandler}
            applyFilterHandler={applyFilterHandler}
            removeFilterHandler={() => {
                setFilterForm({
                    ...EMPTY_FILTER_FORM,
                    appliedFilterCount: 0
                });
                getAllLoanSchemes();
            }}
        />
    )

    return (
        <MuiTable
            rows={schemes}
            columns={columns(loanCategoryPaymodes, dropdownValues)}
            headerComp={loanSchemeHeaderComp}
            userPermissions={userPermissions}
            loading={loading}
            asyncDeleteRow={deleteScheme}
            asyncSaveRow={saveScheme}
            useDeleteIconForCancel={true}
            minHeight={156}
            disableVirtualization={true}
            headerMiscellaneousRightComp={headerMiscellaneousRightComp}
        />
    )
}

export default LoanSchemeMaster;